import React from "react";
import truck from "../assets/img/Truck.png";
import { Col, Navbar, NavbarBrand, Row } from "reactstrap";

function HeaderNavbar() {
    return (
        <>
            <Navbar color="white" className="navbar" fixed="top">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-9 col-sm-9 px-0">
                            <NavbarBrand
                                href="/"
                                className="text-dark navbar__brand"
                            >
                                Where to Buy Detailing Supplies.com <br />
                                <small className="text-secondary">
                                    POWERED BY MYDISTRIBUTIONPARTNER.COM
                                </small>
                            </NavbarBrand>
                        </div>
                        <div className="col-2 col-sm-2 pr-0">
                            <img src={truck} alt=""  width="70rem" height="70rem" />
                        </div>
                    </div>
                </div>
            </Navbar>
        </>
    );
}

export default HeaderNavbar;
